import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface Step {
  id: number;
  label: string;
  icon: React.ElementType;
}
interface ProgressSidebarProps {
  currentStep: number;
  steps: Step[];
}
export function ProgressSidebar({
  currentStep,
  steps
}: ProgressSidebarProps) {
  return <div className="h-full flex flex-col justify-between p-8 md:p-12 text-white" data-id="element-452">
      {/* Logo */}
      <div className="mb-12" data-id="element-453">
        <img src="https://cdn.magicpatterns.com/uploads/jDqix8KpSURZNRuPRDHGRH/Operines-Text-logo-.png" alt="Operines" className="h-8 w-auto" data-id="element-454" />
      </div>

      {/* Steps */}
      <div className="flex-1 flex flex-col justify-center space-y-8" data-id="element-455">
        {steps.map((step, index) => {
        const isCompleted = currentStep > step.id;
        const isCurrent = currentStep === step.id;
        const Icon = step.icon;
        return <motion.div key={step.id} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: index * 0.1
        }} className="flex items-center gap-4" data-id="element-456">
              {/* Icon Circle */}
              <motion.div className={`relative flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${isCompleted ? 'bg-white border-white' : isCurrent ? 'bg-white/20 border-white backdrop-blur-sm' : 'bg-transparent border-white/30'}`} animate={{
            scale: isCurrent ? 1.05 : 1
          }} data-id="element-457">
                {isCompleted ? <Check className="w-6 h-6 text-[#4f1964]" data-id="element-458" /> : <Icon className={`w-6 h-6 ${isCurrent ? 'text-white' : 'text-white/50'}`} data-id="element-459" />}

                {/* Connecting Line */}
                {index < steps.length - 1 && <div className={`absolute top-full left-1/2 -translate-x-1/2 w-0.5 h-8 transition-colors duration-300 ${isCompleted ? 'bg-white' : 'bg-white/20'}`} data-id="element-460" />}
              </motion.div>

              {/* Step Info */}
              <div className="flex-1" data-id="element-461">
                <div className={`text-xs font-medium mb-1 transition-colors duration-300 ${isCurrent ? 'text-white' : 'text-white/60'}`} data-id="element-462">
                  STEP {step.id}
                </div>
                <div className={`text-lg font-semibold transition-colors duration-300 ${isCurrent ? 'text-white' : 'text-white/70'}`} data-id="element-463">
                  {step.label}
                </div>
              </div>
            </motion.div>;
      })}
      </div>

      {/* Footer */}
      <div className="mt-12 text-white/60 text-sm" data-id="element-464">
        © {new Date().getFullYear()} Operines
      </div>
    </div>;
}